$(function() {
    var button = $('#forgotPasswordButton');
    var modal = button.parent('.modal-body');
    var error = modal.find('.alert-danger');
    var success = modal.find('.alert-success');

    button.on('click', function() {
        var email = $('#email').val();

        if (!email) {
            error.removeClass('d-none');
            return;
        }

        $('#forgotPasswordButton').parent('.modal-body').find('.alert').addClass('d-none');

        var request = $.ajax({
            method: 'POST',
            data: { 'email': email },
            url: '/player/forgotpasswordemail'
        });

        request.done(function() {
            success.removeClass('d-none');
        });

        request.fail(function() {
            error.removeClass('d-none');
        });
    });
});